import * as api from 'services/api';
import { addError } from 'actions/error';

export const getEntity =
  (professionId, query, entity = 'reviews') =>
  (dispatch) =>
    api
      .get(`professions/${entity}/${professionId}?${query}`, 'GET_QUESTIONS_LIST', dispatch)
      .catch((error) => {
        dispatch(addError(new Error('GET_QUESTIONS_LIST_ERROR')));
        return error;
      });

export const createEntity =
  (professionId, body, entity = 'reviews') =>
  (dispatch) =>
    api
      .post(`professions/${entity}/${professionId}`, body, 'CREATE_QUESTION', dispatch)
      .catch((error) => {
        switch (error.details) {
          case "Can't create one review of one profession during one hour.":
            dispatch(addError(new Error('CREATE_TIMEOUT_ERROR')));
            break;
          default:
            dispatch(addError(new Error('CREATE_QUESTION_ERROR')));
            break;
        }
        return error;
      });

export const createAnswer =
  (reviewId, body, entity = 'reviews') =>
  (dispatch) =>
    api
      .post(`professions/${entity}/${reviewId}/add-answer`, body, 'CREATE_ANSWER', dispatch)
      .catch((error) => {
        dispatch(addError(new Error('CREATE_ANSWER_ERROR')));
        return error;
      });

export const deleteEntity =
  (reviewId, entity = 'reviews') =>
  (dispatch) =>
    api.del(`professions/${entity}/${reviewId}`, {}, 'DELETE_QUESTION', dispatch).catch((error) => {
      dispatch(addError(new Error('DELETE_QUESTION_ERROR')));
      return error;
    });

export const changeVote =
  (reviewId, body, entity = 'reviews') =>
  (dispatch) =>
    api
      .post(`professions/${entity}/${reviewId}/add-vote`, body, 'UPVOTE_QUESTION', dispatch)
      .catch((error) => {
        dispatch(addError(new Error('UPVOTE_QUESTION_ERROR')));
        return error;
      });
